export default {
  setTempParam (param) {
    window.temporaryParam = param
  },
  getTempParam () {
    return window.temporaryParam
  },
  delayBack () {
    setTimeout(() => {
      $router.back()
    }, 1000)
  },
  setTitle (title) {
    document.getElementsByTagName('title')[0].innerHTML = title
  },
  formatPrice (number) {
    return parseFloat(number / 100).toFixed(2) + '元'
  },
  checkTimeReached (timeStamp) {
    let now = new Date().getTime()
    return timeStamp > 0 ? (now > timeStamp) : false
  },
  showLoading (text) {
    let mask = document.getElementById('mask-transparent')
    mask.style.zIndex = 1000
    resetToastStyle()
    let icon = document.getElementById('weui-toast-i')
    icon.removeAttribute('class')
    icon.setAttribute('class', 'weui-loading weui-icon_toast')
    document.getElementById('toast-text').innerHTML = text === undefined ? '正在加载' : text
  },
  hideLoading () {
    let mask = document.getElementById('mask-transparent')
    mask.style.zIndex = -1
    let toast = document.getElementById('weui-toast')
    toast.style.display = 'none'
  },
  showToast (message, style) {
    let mask = document.getElementById('mask-transparent')
    mask.style.zIndex = 1000
    let toast = document.getElementById('weui-toast')
    resetToastStyle()
    let icon = document.getElementById('weui-toast-i')
    icon.removeAttribute('class')
    if (style === 'success') {
      icon.setAttribute('class', 'weui-icon-success-no-circle weui-icon_toast')
    } else if (style === 'forbidden') {
      icon.setAttribute('class', 'weui-icon-warn weui-icon_toast')
    } else if (style === 'cancel') {
      icon.setAttribute('class', 'weui-icon-cancel weui-icon_toast')
    } else {
      // 纯文本
      toast.removeAttribute('class')
      toast.setAttribute('class', 'weui-toast weui-toast--text weui-toast--visible')
    }
    document.getElementById('toast-text').innerHTML = message === undefined ? '' : message
    console.log(message)
    if (window.qizhiTimer) clearTimeout(this.qizhiTimer)
    window.qizhiTimer = setTimeout(() => {
      this.hideLoading()
    }, 2000)
  },
  hideToast () {
    this.hideLoading()
    if (window.qizhiTimer) clearTimeout(window.qizhiTimer)
  },
  dealwithAddress (address, companyId) {
    // 萧山 病区不显示
    let addressList = address.split('|')
    if (parseInt(companyId) === 8 || parseInt(companyId) === 9) {
      addressList.splice(0, 1)
      addressList.splice(2, 1)
    }
    return addressList.join(' ')
  }
}

function resetToastStyle () {
  let toast = document.getElementById('weui-toast')
  toast.removeAttribute('class')
  toast.setAttribute('class', 'weui-toast weui-toast--visible')
  toast.style.display = 'block'
}
// 成功  weui-icon-success-no-circle
// 转圈 weui-loading
// 禁止 weui-icon-warn
// 取消 weui-icon-cancel



// WEBPACK FOOTER //
// ./src/utils/utils.js